/** @format */

import {
  GET_ABOUTME_FAIL,
  GET_ABOUTME_REQUEST,
  GET_ABOUTME_SUCCESS,
  GET_PROJECTS_REQUEST,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_FAIL,
  GET_WEB_PROJECTS_REQUEST,
  GET_WEB_PROJECTS_SUCCESS,
  GET_WEB_PROJECTS_FAIL,
  GET_MOBILE_PROJECTS_REQUEST,
  GET_MOBILE_PROJECTS_SUCCESS,
  GET_MOBILE_PROJECTS_FAIL,
  GET_API_PROJECTS_REQUEST,
  GET_API_PROJECTS_SUCCESS,
  GET_API_PROJECTS_FAIL,
  GET_UI_PROJECTS_REQUEST,
  GET_UI_PROJECTS_SUCCESS,
  GET_UI_PROJECTS_FAIL,
  GET_OTHER_PROJECTS_REQUEST,
  GET_OTHER_PROJECTS_SUCCESS,
  GET_OTHER_PROJECTS_FAIL,
  POST_COMMENT_REQUEST,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_FAIL,
  GET_SOCIALLINKS_FAIL,
  GET_SOCIALLINKS_SUCCESS,
  GET_SOCIALLINKS_REQUEST,
  GET_TimeStamp_REQUEST,
  GET_TimeStamp_SUCCESS,
  GET_TimeStamp_FAIL,
  GET_CERTIFICATE_REQUEST,
  GET_CERTIFICATE_SUCCESS,
  GET_CERTIFICATE_FAIL,
} from "../constants/notesConstants";

export const getAboutMeReducer = (state = { aboutMe: [] }, action) => {
  switch (action.type) {
    case GET_ABOUTME_REQUEST:
      return { loading: true };
    case GET_ABOUTME_SUCCESS:
      return { loading: false, aboutMe: action.payload };
    case GET_ABOUTME_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getWebProjectsReducer = (state = { webProject: [] }, action) => {
  switch (action.type) {
    case GET_WEB_PROJECTS_REQUEST:
      return { loading: true };
    case GET_WEB_PROJECTS_SUCCESS:
      return { loading: false, webProject: action.payload };
    case GET_WEB_PROJECTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getCertificateReducer = (state = { certificate: [] }, action) => {
  switch (action.type) {
    case GET_CERTIFICATE_REQUEST:
      return { loading: true };
    case GET_CERTIFICATE_SUCCESS:
      return { loading: false, certificate: action.payload };
    case GET_CERTIFICATE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getMobileProjectsReducer = (
  state = { mobileProject: [] },
  action
) => {
  switch (action.type) {
    case GET_MOBILE_PROJECTS_REQUEST:
      return { loading: true };
    case GET_MOBILE_PROJECTS_SUCCESS:
      return { loading: false, mobileProject: action.payload };
    case GET_MOBILE_PROJECTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getApiProjectsReducer = (state = { apiProject: [] }, action) => {
  switch (action.type) {
    case GET_API_PROJECTS_REQUEST:
      return { loading: true };
    case GET_API_PROJECTS_SUCCESS:
      return { loading: false, apiProject: action.payload };
    case GET_API_PROJECTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getUiProjectsReducer = (state = { uiProject: [] }, action) => {
  switch (action.type) {
    case GET_UI_PROJECTS_REQUEST:
      return { loading: true };
    case GET_UI_PROJECTS_SUCCESS:
      return { loading: false, uiProject: action.payload };
    case GET_UI_PROJECTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getOtherProjectsReducer = (
  state = { otherProject: [] },
  action
) => {
  switch (action.type) {
    case GET_OTHER_PROJECTS_REQUEST:
      return { loading: true };
    case GET_OTHER_PROJECTS_SUCCESS:
      return { loading: false, otherProject: action.payload };
    case GET_OTHER_PROJECTS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const postCommets = (state = { Comments: [] }, action) => {
  switch (action.type) {
    case POST_COMMENT_REQUEST:
      return { loading: true };
    case POST_COMMENT_SUCCESS:
      return { loading: false, Comments: action.payload };
    case POST_COMMENT_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getSocialLink = (state = { socialLinks: [] }, action) => {
  switch (action.type) {
    case GET_SOCIALLINKS_REQUEST:
      return { loading: true };
    case GET_SOCIALLINKS_SUCCESS:
      return { loading: false, socialLinks: action.payload };
    case GET_SOCIALLINKS_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};

export const getTimeStamp = (state = { TimeStamp: [] }, action) => {
  switch (action.type) {
    case GET_TimeStamp_REQUEST:
      return { loading: true };
    case GET_TimeStamp_SUCCESS:
      return { loading: false, TimeStamp: action.payload };
    case GET_TimeStamp_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
